export class RerunTestResult {
    RunNumber: number;
    AccessionNumber: string;
    RequestDateTime: Date;
    AnalyzerId: number;
    PreviousRunId?: number;
}
